// config
import { config } from '@shakkerai/config';

// hash
import { calculateHash } from './hash.js';

// client
import { getOssClient } from './get-oss-client.js';

/**
 * modelUpload
 *  分片上传建议对大于100M的文件使用
 *  在目前的业务场景内只有model upload符合
 *  所以固化bizCode为1（社区）
 *  且路径为web/model
 *  目前的分片大小为1M
 * @param {*} uuid
 * @param {*} file
 * @param {*} onCalcHashEnd
 * @param {*} onUploadProgress
 * @returns
 */
export const modelUpload = async (uuid, file, onCalcHashEnd, onUploadProgress) => {
  const methodName = 'modelUpload';
  try {
    // log
    console.info(methodName, 'uuid', uuid);
    console.info(methodName, 'file', file);

    // check
    if (!uuid) {
      console.info(methodName, 'need uuid');
      return;
    }
    if (!file) {
      console.info(methodName, 'need file');
      return;
    }

    // hash
    const fileHash = await calculateHash(file, onCalcHashEnd);
    console.info(methodName, 'fileHash', fileHash);
    if (!fileHash) return;

    // client
    const bizCode = '1';
    const client = await getOssClient(bizCode);
    if (!client) return;

    // filename
    let fileName = file.name;
    const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
    if (fileExtension && fileHash) fileName = fileHash + fileExtension;
    console.info(methodName, 'fileName', fileName);

    // oss path
    const preOssPath = 'web/model';
    const ossPath = `${preOssPath}/${uuid}/${fileName}`;
    console.info(methodName, 'ossPath', ossPath);

    // part size from url
    let partSize = config.modelUploadPartSize;
    const partSizeSearch = new URLSearchParams(location.search).get('partsize');
    if (partSizeSearch) {
      const partSizeInt = parseInt(partSizeSearch);
      if (partSizeInt > 0 && partSizeInt <= 20) partSize = partSizeInt * 1024 * 1024;
    }
    console.info(methodName, 'partSizeSearch', partSizeSearch);
    console.info(methodName, 'partSize', partSize);

    // multipart upload
    const multipartOptions = {
      timeout: config.modelUploadTimeout,
      parallel: config.modelUploadParallel,
      partSize: partSize,
      progress: (percentage, checkpoint, res) => {
        if (onUploadProgress) onUploadProgress(percentage, checkpoint, res);
      },
    };
    console.info(methodName, 'multipartOptions', multipartOptions);

    // upload res
    const multipartRes = await client.multipartUpload(ossPath, file, multipartOptions);
    console.info(methodName, 'multipartRes', multipartRes);
    if (!multipartRes || !multipartRes.res || multipartRes.res.status !== 200) {
      console.error(methodName, 'model upload fail');
      return;
    }

    // return
    const url = `${config.oss.cdnHost}/${ossPath}`;
    const finalRes = {
      bucket: multipartRes.bucket,
      etag: multipartRes.etag,
      file: ossPath,
      url: url,
    };
    console.info(methodName, 'finalRes', finalRes);
    return finalRes;
  } catch (error) {
    console.error(methodName, 'model upload error');
    console.error(methodName, error);
  }
};
